<template>
	<div class="banner">
		<div class="links">
			<a href="https://github.com/Lubez/youtube_code" target="_blank"><img id="twitter" src="../assets/images/twitter.png"></a>
			<a href="http://twitter.com" target="_blank"><img id="github" src="../assets/images/github.png"></a>
			<a href="https://www.youtube.com/channel/UCRNuZwN-QbRsfFOqNCeZo3g" target="_blank"><img id="youtube" src="../assets/images/youtube_icon.png"></a>
		</div>
		<div class="container">
			<div v-if="false" class="column top">
				<Logo />
			</div>
			<div class="column">
				<ul id='l-menu'>
					<li v-for="(link, index) in state.links" :key="index">
						<router-link :to="'/' + link">{{ link }}</router-link>
					</li>
				</ul>
			</div>
			<div v-if="true" class="column">
				<Logo />
			</div>
			<div class="column">
				<ul id='r-menu'>
					<div v-if="!admin">
						<li v-for="(link, index) in state.r_links" :key="index">
							<router-link :to="'/' + link">{{ link }}</router-link>
						</li>
					</div>
					<div v-else>
						<li v-for="(link, index) in state.r_links_admin" :key="index">
							<router-link :to="'/' + link">{{ link }}</router-link>
						</li>
					</div>
				</ul>
			</div>
		</div>
		<div class="user" v-if="username != 'guest'">
			<h3 class="user-info">{{ username }}</h3>
		</div>
		<div class="sign-up-button" v-else-if="signUpEnabled">
			<input class="sign-up" type="button" value="sign up">
		</div>
	</div>
</template>

<script>
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';
import Logo from './Logo';

export default {
	name: 'Banner',
	components: {
		Logo
	},
	setup() {
		const store = useStore()
		const username = computed(() => store.state.userInfo?.username || '')
		const signUpEnabled = computed(() => store.state.toggle.signUp)
		const admin = computed(() => store.state.admin)

		const state = reactive({
			links: ['home', 'code'],
			r_links: ['blog', 'contact'],
			r_links_admin: ['blog', 'contact', 'admin']
		})

		return {
			state,
			store,
			username,
			signUpEnabled,
			admin
		}
	}
}
</script>

<style scoped>

.sign-up-button {
	position: absolute;
	right: 30pt;
	top: 15pt;
}

.sign-up {
	background: black;
	border: 1pt solid white;
	font-size: 12pt;
	border-radius: 10pt;
	color: white;
	width: 100pt;
	height: 20pt;
	cursor: pointer;
}

.user-info {
	color: white;
	opacity: 1;
}

.column {
	flex: 33.33%;
	margin: 10pt;
}

.container {
	display: flex;
	justify-items: center;
	align-items: center;
}

#l-menu {
	float: right;
}

#r-menu {
	float: left;
}

ul {
	/* border: dashed blue; */
	padding: 0;
}

li {
	display: inline;
	list-style-type: none;
	padding: 10pt;
	margin: 0;
	font-size: 25px;
	border-radius: 25pt;
	/* border: dashed green */
	transition: 0.4s
}

li:hover {
	background-color: gray;
}

.links {
	position: absolute;
	left: 10pt;
}

.user {
	position: absolute;
	right: 30pt;
	top: 0pt;
}

img {
	/* border: solid red; */
	margin: 0;
	width: 150pt;
}

#twitter {
	width: 40pt;
	padding: 5pt;
}

#youtube {
	width: 50pt;
}

#github {
	width: 30pt;
	padding: 10pt;
}

@media (max-width: 1000pt) {
	.container {
		flex-direction: column;
	}

	.links {
		left: 24vw;
	}

	#l-menu, #r-menu {
		margin: 5pt 0;
	}

	li {
		margin: 5pt;
		border: 1pt solid black;
	}
}

.top {
	margin-top: 75px;
}
</style>